import { Partner, Product, UserType } from 'BrokerTsLib/src/enums'
import { useMemo } from 'react'

import { useAuth } from '@/context/AuthContext'

import type { IApp } from '@/dtos'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { apps } from '../data/apps'

const isLeasingPartner = (clientKey: keyof typeof Partner) => {
  return isIn(Partner[clientKey], Partner.RLCZ, Partner.LeasingCS, Partner.BMWFS, Partner.MBFS, Partner.VWFS)
}

export const useAvailableApps = (): IApp[] => {
  const { user } = useAuth()

  const filteredApps = useMemo(
    () =>
      apps.filter(
        (x) =>
          user && user.type === UserType.ApplicationUser &&
          (
            (x.product == Product.VehicleInsurance && user?.vehicleRights) ||
            (x.product == Product.TravelInsurance && user?.travelRights) ||
            (x.product == Product.PropertyInsurance && user?.propertyRights) ||
            (x.product == Product.FleetInsurance && user?.fleetRights) ||
            (x.product == Product.LiabilityInsurance && user?.liabilityRights) ||
            (x.product == Product.VehicleLeasingInsurance && (user?.leasingRights || (user?.clientKey && isLeasingPartner(user?.clientKey))))
          )
      ),
    [user],
  )

  return filteredApps
}

export const useAvailableProducts = (): Product[] => {
  const apps = useAvailableApps()
  
  const availableProducts = useMemo(() => apps.map((x) => x.product).reduce<Product[]>((acc, curr) => {
    return acc.includes(curr) ? acc : [...acc, curr]
  }, []), [apps])

  return availableProducts
}
